import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { get } from 'lodash-es';
import { Mutation, useQuery } from 'react-apollo';
import { handleRequestError } from '../../constants/errorCodes';
import { renderToaster, SUCCESS_TOASTER } from '../../constants/toaster';
import { AdminUpdateUserPersonalInfoMutation } from '../../operations/mutations/AdminUpdateUserMutation';
import { CustomButton } from '../../containers';
import { GetCountriesQuery } from '../../operations/queries/GetLocationsQuery';
import { AdminEditPrivateUserProfileData } from './AdminEditPrivateUserProfileData';
import { AdminEditBusinessUserProfileData } from './AdminEditBusinessUserProfileData';
import { USER_ACCOUNT_BUSINESS } from '../../constants/userDefs';
import { GetSingleUserQuery } from '../../operations/queries/GetUsersQuery';
import { usePlacesQuery } from '../../utils/customHooks';

export const AdminEditProfileData = injectIntl(props => {
  const dispatch = useDispatch();
  const { places, loading: loadingPlaces } = usePlacesQuery();
  const { data: dataCountries, loading: loadingCountries } = useQuery(GetCountriesQuery);
  const countries = get(dataCountries, 'countries.countries', []).sort((a, b) =>
    a.nameCro > b.nameCro ? 1 : b.nameCro > a.nameCro ? -1 : 0
  );
  const { user } = props;
  const [allowEdit, setAllowEdit] = useState(false);

  const [isAllowEditModalOpen, setIsAllowEditModalOpen] = useState(false);
  const toggleAllowEditModal = () => {
    setIsAllowEditModalOpen(isAllowEditModalOpen => !isAllowEditModalOpen);
  };

  const inputHandler = (setter, value) => {
    setter(o => ({ ...o, value, invalid: false }));
  };

  return (
    <Mutation
      mutation={AdminUpdateUserPersonalInfoMutation}
      onError={error => handleRequestError(error, dispatch)}
      onCompleted={() => {
        renderToaster(`successMessages.userProfileDataUpdated`, SUCCESS_TOASTER, { intlKey: true });
        setAllowEdit(false);
      }}
      refetchQueries={() => [{ query: GetSingleUserQuery, variables: { id: user.id } }]}>
      {(updateProfileInfo, { loading }) => {
        return (
          <>
            {user.sector === USER_ACCOUNT_BUSINESS ? (
              <AdminEditBusinessUserProfileData
                inputHandler={inputHandler}
                toggleAllowEditModal={toggleAllowEditModal}
                allowEdit={allowEdit}
                updateProfileInfo={updateProfileInfo}
                places={places}
                loadingPlaces={loadingPlaces}
                user={user}
                countries={countries}
                loadingCountries={loadingCountries}
              />
            ) : (
              <AdminEditPrivateUserProfileData
                inputHandler={inputHandler}
                toggleAllowEditModal={toggleAllowEditModal}
                allowEdit={allowEdit}
                updateProfileInfo={updateProfileInfo}
                places={places}
                loadingPlaces={loadingPlaces}
                user={user}
                countries={countries}
                loadingCountries={loadingCountries}
              />
            )}
            <Modal
              modalClassName="hok-modal"
              centered
              size="sm"
              backdrop="static"
              toggle={toggleAllowEditModal}
              isOpen={isAllowEditModalOpen}>
              <ModalHeader className="border-0">
                <Row className="no-gutters auth-nav-links">
                  <Col xs={12}>
                    <h2 className="d-flex align-items-center justify-content-center">
                      <FormattedMessage id="adminEditUserPage.editModalTitle" />
                    </h2>
                  </Col>
                </Row>
              </ModalHeader>
              <ModalBody>
                <Row className="no-gutters px-4 py-3 font-weight-500">
                  <Col xs="12" className="text-center">
                    <FormattedMessage id="adminEditUserPage.editModalContent" />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter className="justify-content-center">
                <Row className="w-100">
                  <Col xs={6}>
                    <CustomButton
                      className="hok-outline-btn"
                      outline
                      translationId="no"
                      onClick={toggleAllowEditModal}
                    />
                  </Col>
                  <Col xs={6}>
                    <CustomButton
                      type="submit"
                      className="hok-dashboard-btn"
                      translationId="yes"
                      onClick={() => {
                        setAllowEdit(true);
                        toggleAllowEditModal();
                      }}
                      loaderProp={loading}
                    />
                  </Col>
                </Row>
              </ModalFooter>
            </Modal>
          </>
        );
      }}
    </Mutation>
  );
});
